import { PentairSilverGray } from '../colors';
export const MuiTable = {
    styleOverrides: {
        root: {
        // '& tbody': {
        //   whiteSpace: 'nowrap',
        // },
        // '& tbody tr:hover': {
        //   background: '#f2f2f2',
        // },
        },
    },
};
export const MuiTableRow = {
    styleOverrides: {
    // root: {
    //   transition: 'background 0.3s',
    //   borderBottomColor: '#DADADA',
    // },
    },
};
export const MuiTableCell = {
    styleOverrides: {
        root: (props) => ({
            borderBottomColor: '#DADADA',
        }),
        head: {
            fontWeight: 600,
            textTransform: 'uppercase',
            color: PentairSilverGray[500],
            fontSize: '0.75rem',
            lineHeight: 1,
        },
        paddingCheckbox: {
            padding: 0,
        },
    },
};
